"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UrlFormatter;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

UrlFormatter.propTypes = _propTypes.EditorProps;

function UrlFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  return value ? /*#__PURE__*/_react["default"].createElement("a", {
    href: value.slice(0, 8).includes("http://") || value.slice(0, 8).includes("https://") ? value : "https://".concat(value),
    target: "_blank",
    style: {
      textDecoration: "underline"
    },
    rel: "noreferrer"
  }, value) : null;
}